import { Text } from "@mantine/core";

import classes from "./_css/DateItem.module.css";

type Props = {
  date: string;
  dayWeek: string;
  isSelected: boolean;
  openCount?: number;
};

export function DateItem({ date, dayWeek, isSelected, openCount }: Props) {
  // 求人数に応じたバッジクラスを返す
  const getBadgeClass = () => {
    if (!openCount || openCount === 0) return "";
    if (openCount <= 2) return classes.badgeUrgent; // 少数の求人: 赤（緊急性高）
    if (openCount <= 4) return classes.badgeMedium; // 中程度の求人: オレンジ
    return classes.badgeMany; // 多数の求人: 青
  };

  const badgeClass = getBadgeClass();

  return (
    <div data-selected={isSelected || undefined} className={classes.dateItem}>
      <Text fz="md" fw={400} pt={2} pb={1}>
        {date}
      </Text>
      <Text fz="sm" c="gray" pb={0}>
        {dayWeek}
      </Text>
      {openCount !== undefined && openCount > 0 && (
        <div className={badgeClass}>{openCount}</div>
      )}
    </div>
  );
}
